export default __webpack_public_path__ + "static/media/floppy.8cbec2f5.svg";